// 一些不影响主流程的，路由相关的方法
import { setSession, getSession, clearCookie, getSystemNewDate, getCookieValue } from '@/utils';
import { common } from '@/api';
import store from '../store';
import { detailMsgs } from '@/utils/bigData'; // 平台流量埋点
import { Message } from 'element-ui';

export const clearBrother = (to, from) => {
  // 如果不是父子&&兄弟页面，跳转页面时清除查询条件
  if (to && from && to.path.indexOf(from.path) < 0 && from.path.indexOf(to.path) < 0) {
    let toArr = to.path.split('/');
    let fromArr = from.path.split('/');
    if (toArr.length >= 4 && fromArr.length >= 4) {
      if (toArr.slice(0, 3).toString() !== fromArr.slice(0, 3).toString()) {
        setSession('queryForm', '');
        console.log('如果不是兄弟页面，跳转页面时清除查询条件');
      }
    } else {
      setSession('queryForm', '');
      console.log('如果不是父子页面，跳转页面时清除查询条件');
    }
  }
  // 如果to不是/social-contact/accusation，from不是/social-contact/account-list/accountDetail，跳转页面时清除查询条件
  if (!(to && from && to.path === '/social-contact/accusation' && from.path === '/social-contact/account-list/accountDetail')) {
    setSession('queryTab', '');
  }
};

// 从dcp 登录后，直接从dep跳转去美居页面，先去后端拿 cookie
export const fromDcpToMeiju = () => {
  let serviceLastIndex = window.location.hash.length;
  if (window.location.hash.indexOf('isFromC4a=') > 0) {
    serviceLastIndex = window.location.hash.indexOf('isFromC4a=') - 1;
  }
  let serviceUrl = window.location.hash.slice(1, serviceLastIndex);
  serviceUrl = serviceUrl.replace('?', '&');
  // 需要清掉当前登录用户信息，让其重新获取菜单和用户信息
  sessionStorage.clear();
  clearCookie('isAlertJumpToCmms', 'cmms.midea.com');
  // store.dispatch('user/setCurrentUser', null);
  console.log('美居跳转过来的，清空用户所有权限缓存222');
  // debugger;
  store.dispatch('user/logoutClearUserInfo');
  setSession('authMenuList', null);
  let protocol = window.location.protocol; // 协议
  if (process.env.ENV_CONFIG === 'prod') {
    window.location.href = protocol + '//cmms.midea.com/cmms/autoLogin/dcpToCmms?serviceUrl=' + serviceUrl;
  } else {
    window.location.href = protocol + '//cmms2.midea.com/cmms/autoLogin/dcpToCmms?serviceUrl=' + serviceUrl;
  }
};

// 每次更新路由都要执行的操作，但是不影响流程
export const everyUpdateRoute = async(to) => {
  // 是否从服务器获取了当前的时间
  if ((!getSession('newDateObj') || !getSession('newDateObj').year) && (to.name !== 'login' && getCookieValue('cmms2_token'))) {
    await getSystemNewDate();
  }
  // 平台流量菜单埋点
  detailMsgs(to);
};

// 没有权限的提示
export const noAuthMessage = (to) => {
  Message({
    showClose: true,
    message: '小主，您无权访问本页面；这里帮您跳到首页~',
    type: 'info',
    duration: 3000
  });
};

// 获取品牌列表
export const getBrandList = (callback, resolve) => {
  // return new Promise((resolve, reject) => {
  common.getAuthBrand().then(res => {
    if (res.code === 0) {
      let resData = res.data;
      let brandList = [];
      for (var keys in resData) {
        let item = {
          name: resData[keys],
          brand: +keys
        };
        brandList.push(item);
      }
      store.dispatch('user/setBrandList', brandList);

      // 当前没有选择品牌的时候，默认第一个品牌
      if (!store.getters['user/brand'] && !getSession('brand') && Array.isArray(brandList) && brandList.length > 0) {
        store.dispatch('user/setBrand', brandList[0].brand);
      }

      if (brandList.length === 0) {
        resolve(false);
      }
      resolve(true);

    } else {
      resolve(false);
    }
  }).catch(() => {
    resolve(false);
  });
  // });
};

export default {
  clearBrother,
  getBrandList
};
